// extracted by mini-css-extract-plugin
export default {"zoomModal":"g4-z","image":"h4-z","button":"i4-z","isOverlayShown":"j4-z"};